class CustomerGalleryFlowbox extends HTMLElement {
  constructor () {
    super()
    this.flowboxKey = null
    this.allTags = []
    this.isInitialized = false
  }

  async connectedCallback () {
    this.flowboxKey = this.dataset.flowboxKey

    if (!this.flowboxKey) {
      return
    }
    this.collectAllTags()
    await this.loadFlowboxScript()
    this.setupFilterButtons()
  }

  collectAllTags () {
    const filterButtons = document.querySelectorAll('.customer-gallery__gallery-filter[data-tag]')
    this.allTags = []

    filterButtons.forEach(button => {
      const tag = button.dataset.tag
      if (tag && tag.trim() !== '') {
        this.allTags.push(tag.trim())
      }
    })
  }

  async loadFlowboxScript () {
    return new Promise((resolve, reject) => {
      if (!window.flowbox) {
        const f = function () { f.q.push(arguments) }
        f.q = []
        window.flowbox = f
      }

      if (document.getElementById('flowbox-js-embed')) {
        this.initFlowbox()
        resolve()
        return
      }

      const script = document.createElement('script')
      script.id = 'flowbox-js-embed'
      script.async = true
      script.src = 'https://connect.getflowbox.com/flowbox.js'

      script.onload = () => {
        this.initFlowbox()
        resolve()
      }

      script.onerror = (error) => {
        console.error('CustomerGalleryFlowbox: Failed to load script', error)
        reject(error)
      }

      document.head.appendChild(script)
    })
  }

  initFlowbox () {
    if (this.isInitialized) {
      return
    }

    try {
      window.flowbox('init', {
        container: '#js-flowbox-flow',
        key: this.flowboxKey,
        locale: 'en-GB',
      })

      this.isInitialized = true
    } catch (error) {
      console.error('CustomerGalleryFlowbox: Failed to initialize', error)
    }
  }

  setupFilterButtons () {
    const filterContainer = document.querySelector('.customer-gallery__gallery-filters')
    if (!filterContainer) {
      console.warn('CustomerGalleryFlowbox: Filter container not found')
      return
    }

    filterContainer.addEventListener('click', (event) => {
      const button = event.target.closest('.customer-gallery__gallery-filter')
      if (!button) return

      event.preventDefault()

      const clickedClearIcon = event.target.closest('.customer-gallery__gallery-filter-icon-clear')
      const tag = button.dataset.tag
      const isActive = button.classList.contains('active')
      const nextTag = clickedClearIcon || isActive ? null : tag

      this.updateActiveButton(button, nextTag)
      this.updateFlowboxContent(nextTag)
      setTimeout(() => {
        this.scrollToFilters()
      }, 100)
    })
  }

  scrollToFilters () {
    const embedElement = document.querySelector('.customer-gallery__embed')
    const galleryElement = document.querySelector('.customer-gallery__gallery')
    const headerElement = document.querySelector('.site-header')

    if (!embedElement || !galleryElement) {
      return
    }

    const embedRect = embedElement.getBoundingClientRect()
    const galleryRect = galleryElement.getBoundingClientRect()
    const filtersHeight = galleryRect.height
    const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 0
    const currentScrollY = window.scrollY || window.pageYOffset
    const embedTop = embedRect.top + currentScrollY
    const targetScrollY = embedTop - filtersHeight - headerHeight - 20

    window.scrollTo({
      top: Math.max(0, targetScrollY),
      behavior: 'smooth',
    })
  }

  updateActiveButton (activeButton, nextTag) {
    const allButtons = document.querySelectorAll('.customer-gallery__gallery-filter')
    allButtons.forEach(btn => btn.classList.remove('active'))

    const allClearIcons = document.querySelectorAll('.customer-gallery__gallery-filter-icon-clear')
    allClearIcons.forEach(icon => icon.classList.add('hidden'))

    if (nextTag) {
      activeButton.classList.add('active')
      const clearIcon = activeButton.querySelector('.customer-gallery__gallery-filter-icon-clear')
      if (clearIcon) clearIcon.classList.remove('hidden')
    }
  }

  updateFlowboxContent (tag) {
    if (!this.isInitialized) {
      console.warn('CustomerGalleryFlowbox: Not initialized yet')
      return
    }

    try {
      if (!tag || tag.trim() === '') {
        window.flowbox('update', {
          container: '#js-flowbox-flow',
          key: this.flowboxKey,
          tags: [],
          tagsOperator: 'any',
        })
      } else {
        window.flowbox('update', {
          container: '#js-flowbox-flow',
          key: this.flowboxKey,
          tags: [tag],
          tagsOperator: 'all',
        })
      }
    } catch (error) {
      console.error('CustomerGalleryFlowbox: Failed to update content', error)
    }
  }
}

if (!customElements.get('customer-gallery-flowbox')) {
  customElements.define('customer-gallery-flowbox', CustomerGalleryFlowbox)
}
